import "./groupCodeButton.css";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import IconCopy from "assets/Icon-Copy.svg";
import { logEducatorDashboard } from "utils";

export const GroupCodeButton = ({ code, disabled, compact, withMenu = false, onCopy }) => {
  const [buttonText, setButtonText] = useState(code.toUpperCase());
  const handleClick = () => {
    if (disabled) {
      alert("You need to select a standard for this group first");
      return;
    }
    navigator.clipboard.writeText(process.env.REACT_APP_OKOLABS_APP_URL + "?code=" + code.toUpperCase())
      .then(() => {
        logEducatorDashboard("Educator dashboard: Group code link copied", {
          event: "group_code_copied",
          groupCode: code,
        });
        if (onCopy) onCopy();
        setButtonText("Copied");
        setTimeout(() => setButtonText(code.toUpperCase()), 2000);
      });
  }
  const compactStyle = compact
    ? { width: 121, height: 48, fontSize: 14, padding: "0 12px" }
    : undefined;
  return (
    <div style={compact ? { display: "inline-block" } : undefined}>
      <Button
        className={`group-code-button${disabled ? " group-code-button-disabled" : ""}${withMenu ? " group-code-button-with-menu" : ""}`}
        onClick={handleClick}
        style={compactStyle}
      >
        <div style={{ alignItems: "center", display: "flex", gap: "8px", justifyContent: "center" }}>
          {withMenu ? (
            <>
              {buttonText}
              <FontAwesomeIcon icon={faEllipsisVertical} />
            </>
          ) : (
            <>
              <img src={IconCopy} alt="copy" />
              {buttonText}
            </>
          )}
        </div>
      </Button>
    </div>
  );
};
